export default {
  route: {
    invalidUrl: 'This URL does not point to a valid project.',
    notFound: "This geometry doesn't exist or you don't have access to it.",
  },
} as const;
